import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGutterVertical32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconGutterVertical32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 7a1 1 0 0 0-2 0 4 4 0 0 0 4 4h12a4 4 0 0 0 4-4 1 1 0 1 0-2 0 2 2 0 0 1-2 2H10a2 2 0 0 1-2-2m1 9a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1m16 10a1 1 0 0 1-1-1 2 2 0 0 0-2-2H10a2 2 0 0 0-2 2 1 1 0 1 1-2 0 4 4 0 0 1 4-4h12a4 4 0 0 1 4 4 1 1 0 0 1-1 1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGutterVertical32);
